import { useState } from "react";
import { useDispatch } from "react-redux";
import Constants from "common/constant";
import { actions } from "features/course/slice";
import { TopTitle } from "./CourseTitle";

export const DefaultStartPage = () => {
  const dispatch = useDispatch();
  const [start, setStart] = useState(true);

  const handleAnimationEnd = () => {
    dispatch(actions.updateShowCourseTop(false));
    setStart(true);
  };

  return (
    <div
      className={`flex-col-el flex-center z-[100] w-full h-full bg-white absolute will-change-transform ${
        start
          ? ""
          : "animate__animated animate__bounceOutUp pointer-events-none"
      }`}
      onAnimationEnd={handleAnimationEnd}
    >
      <div className="flex-col-el flex-center relative w-full h-full">
        <img
          alt="コース スタート画面"
          src={`${Constants.assetHost}/assets/images/display_bg_course.png`}
          className="w-full h-full border-solid border-1 border-textcolor-black object-cover opacity-80 z-[-1]"
        />
        <TopTitle />
      </div>
    </div>
  );
};
